import { render } from "./TachoFileAnalysisView.vue?vue&type=template&id=980d4d94&ts=true"
import script from "./TachoFileAnalysisView.vue?vue&type=script&lang=ts"
export * from "./TachoFileAnalysisView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__